import axios from 'axios';
import ActionTypes from '../constants/action-types';

export const getSearchUsers = (args) => async (dispatch) => {
    dispatch({
        type: ActionTypes.SET_SEARCH_BUSY,
        payload: true
    });
    await axios.get(`/api/trendings`, {
        params: { ...args }
    })
        .then((response) => {
            if (args.perPage < response.data.length) {
                dispatch({
                    type: ActionTypes.SET_SEARCH_HAS_MORE,
                    payload: false
                });
            }
            dispatch({
                type: ActionTypes.SET_SEARCH_USERS,
                payload: response.data.data
            });

            dispatch({
                type: ActionTypes.SET_SEARCH_TOTAL,
                payload: response.data.total
            });

            dispatch({
                type: ActionTypes.SET_SEARCH_BUSY,
                payload: false
            });
        })
        .catch((error) => {
            console.error({ error });
            dispatch({
                type: ActionTypes.SET_SEARCH_BUSY,
                payload: false
            });
        });
};


export const setSearchKeyword = payload => ({
    type: ActionTypes.SET_SEARCH_KEYWORD,
    payload
});

export const resetSearch = payload => ({
    type: ActionTypes.RESET_SEARCH,
    payload
});

export const setSearchType = payload => ({
    type: ActionTypes.SET_SEARCH_TYPE,
    payload
});

export const resetUsers = payload => ({
    type: ActionTypes.RESET_SEARCH_RESULT,
    payload
});